import { CreateWeightClassDto } from '@storage/app/api'
import { WeightClassFormProfile } from './weight-classes-form.profile'

export const mapWeightClassFormProfileToCreateWeightClassDto = (
  weightClassFormProfile: WeightClassFormProfile,
): CreateWeightClassDto[] => {
  return weightClassFormProfile.weightClasses.map(weightClass => ({
    name: weightClass.name,
    minWeight: weightClass.min!,
    maxWeight: weightClass.max,
  }))
}
